(function () {
  'use strict';

  var WHATSAPP_NUMBER = '4915251741750';
  var DISCLOSURE = 'Du schreibst direkt mit der Studio1 Schlafwerkstatt, dem Team hinter bettUP.';

  function cleanExistingGreeting(message) {
    return String(message || '')
      .replace(/^\s*Hallo\s+bettUP(?:-Team)?(?:\s+von\s+Studio1)?,?\s*/i, '')
      .trim();
  }

  function messageFor(link, existingMessage) {
    var body = cleanExistingGreeting(existingMessage);

    if (link.closest('.bettup-home-measure-check')) {
      body = body || [
        'ich möchte prüfen lassen, ob ein neuer Matratzenkern in mein Boxspringbett passt.',
        '',
        'Länge:',
        'Breite:',
        'Kernhöhe:',
        '',
        'Ein Foto sende ich direkt mit.'
      ].join('\n');
    } else if (link.closest('.bu-finder')) {
      body = body || 'ich habe den Kern-Finder genutzt und wünsche eine persönliche Beratung zu meiner Empfehlung.';
    } else {
      body = body || 'ich habe eine Frage zu bettUP.';
    }

    return 'Hallo bettUP-Team von Studio1,\n\n' + body;
  }

  function addDisclosure(link) {
    if (link.closest('footer, .footer')) return;

    var placement = link.closest('.bettup-home-measure-check__actions');
    var parent = placement || link.closest('.bu-finder__contact') || link.parentElement;
    if (!parent) return;

    var existing = placement
      ? placement.parentElement && placement.parentElement.querySelector('.bettup-whatsapp-disclosure')
      : parent.querySelector('.bettup-whatsapp-disclosure');
    if (existing) return;

    var note = document.createElement('small');
    note.className = 'bettup-whatsapp-disclosure';
    note.textContent = DISCLOSURE;

    if (placement) {
      placement.insertAdjacentElement('afterend', note);
    } else {
      parent.appendChild(note);
    }
  }

  function enrichLink(link) {
    if (!link || link.dataset.bettupWhatsappBranded === 'true') return;

    var url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (error) {
      return;
    }

    var number = url.pathname.replace(/\D/g, '');
    if (url.hostname !== 'wa.me' || number !== WHATSAPP_NUMBER) return;

    url.searchParams.set('text', messageFor(link, url.searchParams.get('text')));
    link.href = url.toString();
    link.dataset.bettupWhatsappBranded = 'true';

    var visibleLabel = (link.textContent || '').trim() || 'WhatsApp öffnen';
    link.setAttribute('aria-label', visibleLabel + '. Persönliche Beratung durch das Team der Studio1 Schlafwerkstatt hinter bettUP.');
    addDisclosure(link);
  }

  function clarifyFooter() {
    var footer = document.querySelector('footer, .footer');
    if (!footer || footer.querySelector('[data-bettup-brand-clarified="true"]')) return;

    var paragraphs = footer.querySelectorAll('p');
    for (var i = 0; i < paragraphs.length; i += 1) {
      var text = (paragraphs[i].textContent || '').trim();
      if (/^Whats\s*App:/i.test(text)) {
        paragraphs[i].textContent = text.replace(/^Whats\s*App:/i, 'WhatsApp für bettUP & Studio1:');
        paragraphs[i].setAttribute('data-bettup-brand-clarified', 'true');
      }
    }
  }

  function run() {
    var links = document.querySelectorAll('a[href*="wa.me/4915251741750"]');
    for (var i = 0; i < links.length; i += 1) enrichLink(links[i]);
    clarifyFooter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  var observer = new MutationObserver(run);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(function () { observer.disconnect(); }, 12000);
})();
